import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/policy/components/PrivacyPolicyBody/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonLayout/index.tsx");
